export default "__VITE_ASSET__DQZuO22___"